import Vue from 'vue'
import App from './App.vue'
import '../../lib/base.css'

import { isAuthorised } from '@/lib/auth.js'
import consoleLog from '@/lib/consoleLog.js'

const startApp = () => {
  Vue.config.productionTip = false
  Vue.config.devtools = false

  new Vue({
    render: (h) => h(App),
  }).$mount('#app')
}

isAuthorised()
  .then(() => {
    consoleLog('AUTHORISED')
    Vue.config.gruErrorStatus = false
    startApp()
  })
  .catch((err) => {
    consoleLog('NOT AUTHORISED')
    consoleLog(err)
    Vue.config.gruErrorStatus = true
    startApp()
  })
